import { DatasourceTypeEnum } from '@y42/json-schema';
import { CTypeModel } from '@y42/model';

/**
 * Datasource Type objects from contentful.
 */
export class DatasourceCTypeModel extends CTypeModel<DatasourceTypeEnum> {}

export type DatasourceTypeModel = DatasourceCTypeModel;

export const UNKNOWN_DATASOURCE_TYPE_MODEL: DatasourceTypeModel = new DatasourceCTypeModel({
  type: DatasourceTypeEnum.Unknown,
  rawGuideUrl: '',
  displayName: '',
  description: '',
  logo: '',
  orderNo: 0,
  availabilityLabel: '',
  industry: [],
  color: '',
  articleid: '',
  articleidAuth: '',
  scheduleTime: 0,
  documentationUrl: '',
  isAirbyte: false,
  hasIncremental: false,
  pictureUrl: '',
  authTutorial: '',
  useNewTriggerEndpoint: false,
  hideV2unsupported: false,
});
